<div class="min-h-screen flex" style="background-color: #fafaf7;">
  <app-sidebar></app-sidebar>

  <div class="flex-1 flex flex-col min-w-0">
    <div class="sticky top-0 z-30">
      <app-header></app-header>
    </div>

    <main class="flex-1 p-4 sm:p-6">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
